import { render, staticRenderFns } from "./FacilitiesTable.vue?vue&type=template&id=3918a55a&scoped=true"
import script from "./FacilitiesTable.vue?vue&type=script&lang=js"
export * from "./FacilitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918a55a",
  null
  
)

export default component.exports